import { Link } from 'react-router-dom';
import { OFERTA_PATH } from '../legal/operator';

export default function LegalDoc({ title, children }) {
  return (
    <article className="legal-page">
      <header className="legal-page-header">
        <h1>{title}</h1>
        <p className="legal-page-nav">
          <Link to="/privacy">Политика обработки ПДн</Link>
          <span aria-hidden="true"> · </span>
          <Link to="/consent">Согласие</Link>
          <span aria-hidden="true"> · </span>
          <Link to={OFERTA_PATH}>Договор-оферта</Link>
        </p>
      </header>
      <div className="legal-page-body">{children}</div>
    </article>
  );
}
